import type { AxiosError, AxiosInstance, AxiosResponse } from 'axios'
import type { ApiResponse, AxiosDataResponse } from '../../../config/api-types'
import { JOURNEY_ENDPOINTS } from '../../../config/endpoints'
import type { IJourneyClient } from '../data/data-sources/i-journey-client'
import type {
  JourneyRequest,
  JourneyVerifyRequest,
} from '../domain/models/journey'

export class JourneyService implements IJourneyClient {
  constructor(private readonly axios: AxiosInstance) {}

  async getJourney(params: JourneyVerifyRequest): Promise<ApiResponse> {
    try {
      const result: AxiosResponse<AxiosDataResponse> = await this.axios.get(
        `${JOURNEY_ENDPOINTS.getJourney}/${params.userId}`,
      )

      return {
        data: result.data.data,
        message: result.data.message,
        status: result.status,
        success: result.data.success,
      }
    } catch (error) {
      const axiosError = error as AxiosError<AxiosDataResponse>

      return {
        message:
          axiosError.response?.data?.message || 'Error al verificar journey',
        status: axiosError.response?.status || 500,
        success: false,
      }
    }
  }

  async createJourney(params: JourneyRequest): Promise<ApiResponse> {
    try {
      const result: AxiosResponse<AxiosDataResponse> = await this.axios.post(
        JOURNEY_ENDPOINTS.createJourney,
        params,
      )

      return {
        data: result.data.data,
        message: result.data.message,
        status: result.status,
        success: result.data.success,
      }
    } catch (error) {
      const axiosError = error as AxiosError<AxiosDataResponse>

      return {
        message: axiosError.response?.data?.message || 'Error al crear journey',
        status: axiosError.response?.status || 500,
        success: false,
      }
    }
  }

  async concludeJourney(journeyId: number): Promise<ApiResponse> {
    try {
      const result: AxiosResponse<AxiosDataResponse> = await this.axios.post(
        `${JOURNEY_ENDPOINTS.concludeJourney}?journeyId=${journeyId}`,
      )

      return {
        data: result.data.data,
        message: result.data.message,
        status: result.status,
        success: result.data.success,
      }
    } catch (error) {
      const axiosError = error as AxiosError<AxiosDataResponse>

      return {
        message:
          axiosError.response?.data?.message || 'Error al concluir la jornada',
        status: axiosError.response?.status || 500,
        success: false,
      }
    }
  }
}
